<script>
import HeaderView from '../../../shared/views/HeaderView';
import MainMenuInstructorView from '../../../shared/views/MainMenuInstructorView';
import LiveClassDetailComponent from '../../features/details/LiveClassDetailComponent';

export default {
  components: {
    HeaderView,
    MainMenuInstructorView,
  },
  extends: LiveClassDetailComponent,
};
</script>

<template>
  <div>
    <header-view />
    <main-menu-instructor-view />
    <div
      v-loading="isItemLoading"
      class="wrapper"
      :element-loading-text="itemLoadingMessage"
    >
      <div class="sa4d25">
        <div class="container-fluid">
          <div
            v-if="liveClassDetails"
            class="row"
          >
            <!-- Encabezado de Detalles de la Clase -->
            <div class="col-12">
              <div class="stream_detail_header">
                <div class="stream_detail_title_wrap">
                  <router-link
                    to="/profesor/en-vivo"
                    class="btn_back_streams"
                  >
                    <i class="fas fa-arrow-left" /> Volver a Clases en Vivo
                  </router-link>
                  <h2 class="stream_detail_title">
                    {{ liveClassDetails.title }}
                  </h2>
                </div>
                <div class="stream_detail_badges">
                  <span
                    v-if="liveClassDetails.course"
                    class="detail_course_badge"
                  >
                    <i class="fas fa-graduation-cap" />
                    {{ liveClassDetails.course.title || liveClassDetails.course }}
                  </span>
                  <span
                    v-if="!liveClassDetails.isFinished"
                    class="detail_live_badge"
                  >
                    <span class="live_dot" /> EN VIVO
                  </span>
                  <span
                    v-else
                    class="detail_finished_badge"
                  >
                    <i class="fas fa-video" /> GRABACIÓN
                  </span>
                </div>
              </div>
            </div>

            <!-- Reproductor y Detalles del Instructor -->
            <div class="col-xl-8 col-lg-8">
              <div class="section3125">
                <div class="live1452 stream_player_card">
                  <iframe
                    :src="liveClassDetails.streamUrl"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; unload"
                    allowfullscreen
                  />
                </div>
                <div class="user_dt5 stream_info_card">
                  <div class="user_dt_left">
                    <div class="live_user_dt">
                      <div class="user_img5">
                        <img
                          :src="mapProfileImageUrl(liveClassDetails.publisherImageUrl)"
                          :alt="liveClassDetails.publisherTitle"
                          @error="onAvatarError"
                        >
                      </div>
                      <div class="user_cntnt">
                        <h4>{{ liveClassDetails.publisherTitle || 'Profesor' }}</h4>
                        <span class="stream_instructor_badge">
                          <i class="fas fa-chalkboard-teacher" /> Instructor de la Clase
                        </span>
                      </div>
                    </div>
                    <div
                      v-if="liveClassDetails.description"
                      class="stream_description_box"
                      v-html="liveClassDetails.description"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- Chat En Vivo -->
            <div class="col-xl-4 col-lg-4">
              <div class="right_side">
                <div class="fcrse_3 stream_chat_card">
                  <div class="cater_ttle">
                    <h4>
                      <i class="fas fa-comments" /> Chat En Vivo
                    </h4>
                    <span class="chat_count_pill">
                      {{ chat ? chat.length : 0 }} mensajes
                    </span>
                  </div>
                  <div class="live_chat">
                    <div class="chat1">
                      <template v-if="chat && chat.length > 0">
                        <div
                          v-for="item in chat"
                          :key="item.id"
                          class="chat_message_item"
                        >
                          <span class="chat_author_name">{{ item.account?.username || 'Usuario' }}:</span>
                          <span class="chat_message_text">{{ item.description }}</span>
                        </div>
                      </template>
                      <div
                        v-else
                        class="chat_empty_state"
                      >
                        <i class="far fa-comment-dots" />
                        <p>Aún no hay mensajes en el chat.</p>
                      </div>
                    </div>
                  </div>
                  <div class="live_comment">
                    <el-input
                      v-model="message"
                      class="chat_composer"
                      placeholder="Escribe un mensaje en el chat..."
                      @keyup.enter="sendMessage"
                    >
                      <template #append>
                        <el-button
                          class="chat_send_btn"
                          type="primary"
                          title="Enviar mensaje"
                          aria-label="Enviar mensaje"
                          @click="sendMessage"
                        >
                          <i class="fas fa-paper-plane" />
                        </el-button>
                      </template>
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
